import {CommonModule} from '@angular/common';
import {LucideAngularModule} from 'lucide-angular';
import {httpLoaderFactory} from './app.module';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorIntl, MatPaginatorModule} from '@angular/material/paginator';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSortModule} from '@angular/material/sort';
import {CdkMenuModule} from '@angular/cdk/menu';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CodeInputComponent} from './components/form/inputs/code-input/code-input.component';
import {AppConfimActionComponentMT} from './components/material/confirm-dialog/app-confim-action.component';
import {AppPinDialogComponentMT} from './components/material/pin-dialog/app-pin-dialog.component';
import {AppMTTasksTable} from './controllers/tasks/table-tasks-mt/table-tasks-mt';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {CdkDrag, DragDropModule} from '@angular/cdk/drag-drop';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatBadgeModule} from '@angular/material/badge';
import {AppTaskUsersList} from './components/material/task-users-list/task-users-list';
import {MyCustomPaginatorIntl} from './components/material/mat-paginator-localize';
import {ComponentsModule} from './components/components.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {AppContentDialogComponentMT} from './components/material/content-dialog/app-content-dialog.component';
import {RouterModule} from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import {AppAddMemberFormComponentMT} from "./modules/contracts/components/forms/add-member/add-member-form.component";
import {AppMTContractTable} from "./modules/contracts/controller/table-contracts-mt/contract-table-mt";
import {
    AppUISettingsCTFormComponent
} from "./modules/contracts/controller/table-contracts-mt/ui-settings/ui-settings-ct-form.component";
import {
    AppCreditLetterSignFormComponentMT
} from "./modules/contracts/components/forms/credit-letter-sign/credit-letter-sign";


@NgModule({
    declarations: [
        AppConfimActionComponentMT,
        AppPinDialogComponentMT,
        AppMTTasksTable,
        AppTaskUsersList,
        AppContentDialogComponentMT,
        AppAddMemberFormComponentMT,
        AppMTContractTable,
        AppUISettingsCTFormComponent,
        AppCreditLetterSignFormComponentMT,
    ],
    imports: [
        CommonModule,
        ComponentsModule,
        CdkDrag,
        DragDropModule,
        ReactiveFormsModule,
        RouterModule,
        FormsModule,
        MatDialogModule,
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatIconModule,
        MatTooltipModule,
        MatButtonToggleModule,
        MatPaginatorModule,
        MatTableModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatExpansionModule,
        MatSortModule,
        CdkMenuModule,
        MatMenuModule,
        MatListModule,
        MatBadgeModule,
        MatCheckboxModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient],
            },
            defaultLanguage: 'ru',
        }),
        CodeInputComponent,
        LucideAngularModule,
    ],
    exports: [
        AppMTTasksTable,
        AppContentDialogComponentMT,
        AppMTContractTable,
        AppCreditLetterSignFormComponentMT,
    ],
    providers: [
        {
            provide: MatPaginatorIntl,
            useFactory: (translate:any) => {
                const service = new MyCustomPaginatorIntl();
                service.injectTranslateService(translate);
                return service;
            },
            deps: [TranslateService]
        },
    ]
})
export class AppMaterialModule {
}
